import { FC, useMemo } from 'react';

import { APTypography } from '@astropay/web-core-library';
import { Box } from '@material-ui/core';

import { translate } from 'common/config/i18n';
import { useDesktopMode } from 'common/helpers/hooks';
import { getMobileOperatingSystem, OS_SYSTEM } from 'common/helpers/utils';

import DownloadButton from './download-button/download-button';
import { useNewDownloadAppStyles } from './new-download-app-styles';

const NewDownloadApp: FC<{ title?: string }> = ({ title = translate('download_app_title1') }) => {
  const classes = useNewDownloadAppStyles();
  const isDesktopMode = useDesktopMode();
  const system = useMemo(getMobileOperatingSystem, [isDesktopMode]);

  return (
    <Box className={classes.root}>
      <Box className={classes.texts}>
        <APTypography textStyle="Typography_Poppins_14px_Regular">{title}</APTypography>
      </Box>

      <Box className={classes.buttonsContainer}>
        {system === OS_SYSTEM.UNKNOWN ? (
          <>
            <DownloadButton system={OS_SYSTEM.IOS} size="lg" />
            <DownloadButton system={OS_SYSTEM.ANDROID} size="lg" />
          </>
        ) : (
          <DownloadButton system={system} size="lg" />
        )}
      </Box>
    </Box>
  );
};

export default NewDownloadApp;
